"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/shared/ui/avatar";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/components/shared/ui/dropdown-menu";
import { UserIcon } from "lucide-react";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import Logout from "./logout";

interface UserIconProps {
    imageUrl?: string;
}

export default function UserIconMenu({ imageUrl }: UserIconProps) {
    const session = useSession();
    const router = useRouter();
    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="ml-4 cursor-pointer" asChild>
                <Avatar>
                    <AvatarImage src={imageUrl} />
                    <AvatarFallback>
                        <UserIcon className="h-5 w-5" />
                    </AvatarFallback>
                </Avatar>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="cursor-pointer">
                <DropdownMenuItem asChild className="hover:bg-accent hover:underline">
                    <Logout className="" />
                </DropdownMenuItem>
                {session?.data?.user?.powerUser && (
                    <DropdownMenuItem className="cursor-pointer hover:underline" asChild>
                        {/* using <Link></Link> here caused weird UI behavior */}
                        <div
                            onClick={() => {
                                router.push("/manage");
                            }}
                        >
                            Manage User Access
                        </div>
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
